export const STORE_GROUP_SEARCH = 'STORE_GROUP_SEARCH';
